/**
 * @file cart-look-context.ts
 * @description Общий контракт групп панели «Вид корзины» (phase19.16, партия
 * SB120, этап 4; uiux-cart §5): раздел корзины, тема (цвета, шапка,
 * скругление сайта), предупреждения `cartLookWarnings`, только ли просмотр,
 * запись и живой предпросмотр. Группы читают его из контекста — без
 * протаскивания шести пропсов через каждую (образец value/onChange-контракта
 * CarrierMainFields, но одним объектом на панель).
 */

import type { SiteCart, SiteCartWarning, SiteTheme } from "@chaiberi/shared";
import { createContext, useContext } from "react";

export interface CartLookApi {
  cart: SiteCart;
  theme: SiteTheme;
  /** Без права THEME — поля неактивны, запись не уходит. */
  readOnly: boolean;
  warnings: SiteCartWarning[];
  /** Правка раздела: вложенные `drawer`/`popover` — целиком (`{ ...cart.drawer, side }`). */
  change: (patch: Partial<SiteCart>) => void;
  /** Показать на канве во время перетаскивания ползунка (не запись). */
  preview: (patch: Partial<SiteCart>) => void;
}

export const CartLookContext = createContext<CartLookApi | null>(null);

export function useCartLook(): CartLookApi {
  const api = useContext(CartLookContext);
  if (!api) throw new Error("useCartLook(): группа «Вида корзины» рисуется только внутри CartLookFields");
  return api;
}
